/**
 * Scroll reveals and count-up numbers.
 *
 * [data-reveal]    gets .is-revealed when it scrolls into view (styles in critical.css).
 * [data-count-to]  counts up from 0 to its value when it scrolls into view. The element already
 *                  contains the final number, so it reads correctly without JavaScript and for
 *                  search engines. Optional data-count-decimals (default 0). Dutch number format.
 */
(function () {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.__revealReady = true;

  function countUp(element) {
    const target = parseFloat(element.dataset.countTo);
    if (Number.isNaN(target) || reduceMotion) return;

    const decimals = parseInt(element.dataset.countDecimals || '0', 10);
    const format = new Intl.NumberFormat('nl-NL', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    const duration = 1600;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      element.textContent = format.format(target * eased);
      if (progress < 1) requestAnimationFrame(tick);
    };

    element.textContent = format.format(0);
    requestAnimationFrame(tick);
  }

  function reveal(element) {
    element.classList.add('is-revealed');
  }

  function init(scope) {
    const revealElements = scope.querySelectorAll('[data-reveal]:not(.is-revealed)');
    const counters = scope.querySelectorAll('[data-count-to]:not([data-counted])');

    if (!('IntersectionObserver' in window)) {
      revealElements.forEach(reveal);
      return;
    }

    // An element taller than the viewport can never be 8% visible, so it is revealed as soon as it
    // enters (long policy texts, for example).
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const viewportHeight = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
          if (entry.intersectionRatio < 0.08 && entry.boundingClientRect.height <= viewportHeight) continue;
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: [0, 0.08] }
    );

    const counterObserver = new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.dataset.counted = '';
          countUp(entry.target);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.6 }
    );

    revealElements.forEach((element) => revealObserver.observe(element));
    counters.forEach((element) => counterObserver.observe(element));
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Content that is hidden for a reveal must never stay hidden.
  if (!root.classList.contains('js-reveal')) {
    document.querySelectorAll('[data-reveal]').forEach(reveal);
  }
})();
